import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseWalletsSearch } from "@/features/money";
import { WalletsPage } from "@/features/money/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/money/wallets/")({
  validateSearch: strictSearch(parseWalletsSearch),
  component: Wallets,
});

function Wallets() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <WalletsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(providerId) =>
        router.buildLocation({ to: "/money/wallets/$providerId", params: { providerId } }).href
      }
      onOpen={(providerId) =>
        void router.navigate({ to: "/money/wallets/$providerId", params: { providerId } })
      }
    />
  );
}
